/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {RunnerPageOf, RunnerPageOfFromJSON, RunnerPageOfToJSON,} from './RunnerPageOf';

/**
 *
 * @export
 * @interface RunnerPageOfApiResult
 */
export interface RunnerPageOfApiResult {
    /**
     *
     * @type {boolean}
     * @memberof RunnerPageOfApiResult
     */
    success?: boolean;
    /**
     *
     * @type {RunnerPageOf}
     * @memberof RunnerPageOfApiResult
     */
    content?: RunnerPageOf;
    /**
     *
     * @type {string}
     * @memberof RunnerPageOfApiResult
     */
    message?: string | null;
}

export function RunnerPageOfApiResultFromJSON(json: any): RunnerPageOfApiResult {
    return RunnerPageOfApiResultFromJSONTyped(json, false);
}

export function RunnerPageOfApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunnerPageOfApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : RunnerPageOfFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function RunnerPageOfApiResultToJSON(value?: RunnerPageOfApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': RunnerPageOfToJSON(value.content),
        'message': value.message,
    };
}

